import moment from "moment";
import CarrelloRiga from "@/models/Carrello/carrelloRiga.model.js";
import Carrello from "@/models/Carrello/carrello.model.js";

const state = {
    carrello: null,
    carrelloTmp: null
}

const getters = {
    getCarrelloTmp: (state) => {
        return state.carrelloTmp;
    },
    getNumeroRigheCart: (state) => {
        let carrello = state.carrelloTmp;
        if(carrello != null && carrello.Righe != null){
            return carrello.Righe.length;
        }else{
            return 0;
        }
    },
    getPrezzoTotaleTmp: (state) => {
        let prezzoTotale = 0;
        if(state.carrelloTmp && state.carrelloTmp.Testata){
            prezzoTotale = state.carrelloTmp.Testata.PrezzoTotale;
        }
        return prezzoTotale;
    },
}

const mutations = {
    updateCarrello: (state, carrello) => {
        state.carrello = carrello;
        sessionStorage.setItem('carrello', JSON.stringify(state.carrello));
    },
    updateRow: (state, data) => {
        let currentCarrello = state.carrelloTmp;
        if(!currentCarrello){
            currentCarrello = new Carrello();
            currentCarrello.Testata.DataModifica = moment().format("YYYY-MM-DD HH:mm:ss");
        }
        currentCarrello.Testata.DataModifica = moment().format("YYYY-MM-DD HH:mm:ss");
        let index = currentCarrello.Righe.findIndex(value => {
            return value.CodiceArticolo === data.CodiceArticolo;
        });
        let  articolo = new CarrelloRiga();
        if(index < 0){
            index = currentCarrello.Righe.length
            articolo.Quantita = 0;
        }
        else{
            Object.assign(articolo, currentCarrello.Righe[index]);
        }
        articolo.setDati(
            data.IdOrdine,
            data.CodiceArticolo,
            data.Quantita,
            data.PrezzoNetto,
            data.PrezzoListino,
            data.Sconto1,
            data.Sconto2,
            data.Sconto3,
            data.Sconto4,
            data.Sconto5,
            data.ValoreSconto1,
            data.ValoreSconto2,
            data.ValoreSconto3,
            data.ValoreSconto4,
            data.ValoreSconto5,
            (data.PrezzoNetto * data.Quantita),
            data.Catalogo,
            data.DescrizioneArticolo,
            data.DescrizioneTaglia,
            data.DescrizioneColore,
            data.UrlImmagine,
            data.PrezzoAgente,
            (data?.IsBackorder ?? 0),
            data?.VenditaSoloMultipli,
            data?.Multipli,
            data?.FromOF ?? 0
        );
        if(articolo.Quantita == 0){
            currentCarrello.Righe.splice(index, 1);
        }
        else{
            currentCarrello.Righe[index] = articolo;
        }
        currentCarrello.Testata.PrezzoTotale = 0;
        currentCarrello.Righe.forEach(element => {
            currentCarrello.Testata.PrezzoTotale += element.PrezzoTotale;
        });
        state.carrelloTmp = currentCarrello;
    },
    RemoveCart: (state) => {
        state.carrello = null;
        localStorage.removeItem("carrello");
    },
    resetCarrelloTmp: (state) => {
        state.carrelloTmp = null;
    }
}

const actions = {
    resetCarrello:({commit}) => {
        commit("resetCarrelloTmp");
    },
    resetCarrelloSrv:({commit}) => {
        commit("RemoveCart");
    }
}

export default {
    namespeced: true,
    state,
    getters,
    mutations,
    actions
}